const SHIFT_COORD_LG_FOR_MOBILE = -0.00065;
const SHIFT_COORD_LT_FOR_MOBILE = 0.00002;
const SHIFT_COORD_LG_FOR_TABLET = 0.00025;
const SHIFT_COORD_LT_FOR_TABLET = 0.0004;
const SHIFT_COORD_LT_FOR_DESKTOP = 0.0007;
const RESTRICT_MAP_AREA = [[79.27135, -35.51953], [-35.59522, -142.91016]];

import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const";
/**
 * Компонент карта.
 */
class MapEthiopia {
    defaultOptionPlacemark = {
        iconLayout: "default#image",
        iconImageHref: "https://inter.mfua.ru/assets/images/pin-ethiopia.png",
        iconImageSize: [64, 72],
        iconImageOffset: [-32, -36],
    };
    /**
     * Создает карту с указанными настройками.
     *
     * @param {HTMLElement} mapNode Элемент "карта".
     */
    constructor(mapNode) {
        this.map = mapNode;
        this.lg = mapNode.getAttribute("data-lg");
        this.lt = mapNode.getAttribute("data-lt");
        this.zoom = mapNode.getAttribute("data-zoom");
        this.getCoordsCenterMap()
        document.addEventListener("maponload", this.onMapLoaded);
    }

    /**
     * Указываем параметры для карты (Метку на карте, зум, и другое).
     *
     * @returns {void}
     */

    async createMap() {
        return new Promise((resolve) => {
            ymaps.ready(() => {
                const map = new ymaps.Map(this.map.getAttribute("id"), {
                    center: this.getCoordsCenterMap(),
                    zoom: this.zoom,
                    controls: [],
                }, {                    
                    suppressMapOpenBlock: true,
                    yandexMapDisablePoiInteractivity: true,
                    minZoom: 4,
                    restrictMapArea: RESTRICT_MAP_AREA,
                });

                const placemark = new ymaps.Placemark([this.lg, this.lt], {}, {
                    iconLayout: this.defaultOptionPlacemark.iconLayout,
                    iconImageHref: this.defaultOptionPlacemark.iconImageHref,
                    iconImageSize: this.defaultOptionPlacemark.iconImageSize,
                    iconImageOffset: this.defaultOptionPlacemark.iconImageOffset,
                });

                // Подключение кнопок масштабирования карты
                const zoomControl = new ymaps.control.ZoomControl({
                    options: {
                        size: "small",
                        position: {
                            top: 250,
                            right: 16,
                            left: "auto",
                        }
                    }
                });
                map.controls.add(zoomControl);
                map.geoObjects.add(placemark)

                this.map = map;

                resolve({
                    map: this.map,
                    objects: this.geoObjects,
                })
            });
        })
    }
    onMapLoaded = async () => {
        await this.createMap();
    }

    /**
     * Получить координаты центра карты.
     * 
     * @returns {Array} Координаты с учетом сдвига на карте.
     */
    getCoordsCenterMap() {
        const coordLgForMobile = String(parseFloat(this.lg) + SHIFT_COORD_LG_FOR_MOBILE);
        const coordLtForMobile = String(parseFloat(this.lt) - SHIFT_COORD_LT_FOR_MOBILE);
        const coordLgForTablet = String(parseFloat(this.lg) - SHIFT_COORD_LG_FOR_TABLET);
        const coordLtForTablet = String(parseFloat(this.lt) - SHIFT_COORD_LT_FOR_TABLET);
        const coordLtForDesktop = String(parseFloat(this.lt) - SHIFT_COORD_LT_FOR_DESKTOP);

        if (window.innerWidth < MD_WIDTH) {
            return [coordLgForMobile, coordLtForMobile];
        } else if (window.innerWidth >= MD_WIDTH && window.innerWidth < LG_WIDTH) {
            return [coordLgForTablet, coordLtForTablet];
        } else {
            return [this.lg, coordLtForDesktop];
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const mapNode = document.querySelector(".js-map-ethiopia");
    if (mapNode) {
        new MapEthiopia(mapNode);
    }
});
